export const SYNC = {
	SYNC_CONTENT: "SYNC_CONTENT",
	ASSET_MAP: "ASSET_MAP",
	TOPIC_MAP: "TOPIC_MAP",
};
